import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useEffect, useState } from 'react'
import CSVReader from 'react-csv-reader'
import { openGlobalSnack } from '../utils/snack';
import { isValidCPF } from '../../utils/cpf';
import { justNumbers } from '../../utils/justnumbers';
import { LoadingButton } from '@mui/lab';
import { sendServerRequest } from '../../server/request';
import { serverRequestError } from '../utils/checkservererror';
import { buildPhoneVariants } from "../../utils/phone";
export function CsvReaderCpfAndPhone(){
    const [open,setOpen]=useState(false);
    return (<div>
        <Button variant='contained' onClick={()=>setOpen(true)}>Adicionar Leads</Button>
        <DialogAdd open={open} close={()=>setOpen(false)}/>
    </div>)
}

function DialogAdd({open,close}:{open:boolean,close:Function}){
    const [data,setData]=useState<Array<{cpf:string,phone:string}>>([]);
    const [uploading,setUploading]=useState(false);
    useEffect(()=>{
         setData([]);
    },[open]);
    useEffect(()=>{
       if(!uploading)return;
       sendServerRequest(
        'POST','/server/userLeads/clt/uploadLeads',{leads:data}
       ).then(e=>{
            const {
             savedTotal,
             existsTotal
            }=e.data.data;
            openGlobalSnack(`Leads adicionados. Novos:${savedTotal} Ja Existentes:${existsTotal}`,'success');
            setUploading(false);
            setData([]);
            
       }).catch(e=>{
            console.log(e);
            serverRequestError(e);
            setUploading(false);
       });
    },[uploading])
    return <Dialog open={open}>
        <DialogTitle>Adicione o CSV com o cpf e o telegone</DialogTitle>
        <DialogContent>
            <CSVReader onFileLoaded={(fileData:Array<Array<string>>, fileInfo, originalFile) =>{
                 if(fileData.length<2){
                     openGlobalSnack('Arquivo Vazio','warning');
                     return;
                 }
                 const header=fileData[0];
                 let cpfIndex=-1;
                 let phoneIndex=-1;
                 for(let i=0;i<header.length;i++){
                     if(header[i].toLowerCase().includes('cpf')){
                        cpfIndex=i;
                        continue;
                     }
                     if(header[i].toLocaleLowerCase().includes('one')){
                        phoneIndex=i;
                        continue;
                     }
                 }
                 if(phoneIndex<0||cpfIndex<0||cpfIndex==phoneIndex){
                         openGlobalSnack('CSV deve contar os campos, cpf e telefone','warning');
                         return;
                 }
                 let useData:Array<{cpf:string,phone:string}>=[];
                 for(let i=1;i<fileData.length;i++){
                     const data=fileData[i];

                     const cpf=data[cpfIndex];
                     if(!isValidCPF(cpf||''))continue;
                     const phone=normalizePhone(data[phoneIndex]||'');
                     if(phone.length!=13)continue;
                     useData.push({
                        cpf,phone
                     });
                 }
                 if(useData.length==0){
                    openGlobalSnack('Não foi encontrado leads validos.','warning');
                 }
                 setData(useData);
            }} />
            {data.length>0?<div>
                  <p>{`Foram encontrados ${data.length} Leads`}</p>
                  
            </div>:null}    
        </DialogContent>
        <DialogActions>
            <LoadingButton loading={uploading} disabled={data.length<1} onClick={()=>{
                 setUploading(true);
            }} variant='contained'>Upar Leads</LoadingButton>
            <Button disabled={uploading} onClick={()=>{
                  close();
            }} variant='contained'>Sair</Button>
        </DialogActions>
    </Dialog>
} 


function normalizePhone(phone:string){
      return buildPhoneVariants(phone)?.[0]??'';
}